import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Loader2, CheckCircle2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ConsultaMineralAguardando() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const orderId = params.get("order");
  const [status, setStatus] = useState("aguardando pagamento");
  const [error, setError] = useState(null);
  const timerRef = useRef();

  useEffect(() => {
    if (!orderId) { setError("Order ID ausente"); return; }
    let cancelled = false;
    const poll = async () => {
      try {
        const r = await axios.get(`${API}/api/public/mineral/resolve/${orderId}`);
        if (r.data.ready && r.data.share_token) {
          if (!cancelled) nav(`/consulta-mineral/relatorio/${r.data.share_token}`, { replace: true });
          return;
        }
        if (!cancelled) {
          setStatus(r.data.status || "processando");
          timerRef.current = setTimeout(poll, 3500);
        }
      } catch (e) {
        if (!cancelled) {
          setError(e?.response?.data?.detail || "Falha ao consultar status");
          timerRef.current = setTimeout(poll, 6000);
        }
      }
    };
    poll();
    return () => { cancelled = true; clearTimeout(timerRef.current); };
  }, [orderId, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6"
         style={{ background: "linear-gradient(180deg, #050810 0%, #0B1B2F 100%)" }}
         data-testid="consulta-mineral-aguardando">
      <div className="max-w-md w-full bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 text-center">
        <div className="inline-flex w-14 h-14 rounded-full items-center justify-center mb-4"
             style={{ background: "linear-gradient(135deg, #D4AF37 0%, #B45309 100%)" }}>
          <Loader2 className="w-6 h-6 text-white animate-spin"/>
        </div>
        <div className="text-[11px] tracking-[.3em] uppercase font-semibold mb-2" style={{ color: "#F0D37A" }}>
          Hermes Mineral
        </div>
        <h1 className="font-heading text-2xl text-white font-semibold mb-3">Gerando seu relatório</h1>
        <p className="text-neutral-300/70 text-sm leading-relaxed">
          {status === "ready" || status === "delivered" ? (
            <><CheckCircle2 className="inline w-4 h-4 mr-1"/> Pronto! Redirecionando…</>
          ) : (
            <>Estamos consultando a base oficial da ANM e acionando a LUNA para gerar sua análise jurídica. Você também receberá por e-mail assim que estiver pronto.</>
          )}
        </p>
        <div className="mt-6 flex items-center justify-center gap-2 text-[11px] text-white/50">
          <span className="inline-block w-2 h-2 rounded-full bg-emerald-400 animate-pulse"/>
          Status atual: <strong className="text-white/80 ml-1">{status}</strong>
        </div>
        {error && (
          <div className="mt-4 text-xs text-rose-300/80" data-testid="aguardando-error">{error}</div>
        )}
        <Link to="/consulta-mineral" className="mt-6 inline-block text-xs text-white/40 hover:text-white/70">
          Nova consulta
        </Link>
      </div>
    </div>
  );
}
